// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const diancie_mega: PokeData = {
  "id": 10075,
  "name": "diancie-mega",
  "height": 11,
  "weight": 278,
  "base_experience": 315,
  "types": [
    PokeType.ROCK,
    PokeType.FAIRY
  ],
  "api_moves": [
    "tackle",
    "rock-throw",
    "harden",
    "light-screen",
    "reflect",
    "sharpen",
    "flail",
    "safeguard",
    "ancient-power",
    "skill-swap",
    "power-gem",
    "trick-room",
    "stone-edge",
    "stealth-rock",
    "guard-split",
    "smack-down",
    "moonblast",
    "diamond-storm"
  ],
  "moves": [
    "tackle",
    "rock-throw",
    "reflect",
    "ancient-power",
    "stealth-rock",
    "moonblast",
    "rock-tomb",
    "rock-slide",
    "starfall",
    "rock-smash",
    "stone-axe",
    "play-rough",
    "seismic-toss"
  ],
  "evolution_chain": {
    "id": 371,
    "item": null,
    "species": [
      {
        "name": "diancie",
        "order": 719,
        "types": [
          PokeType.ROCK,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 91,
    "speed": 126,
    "ability_power": 183
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": false,
  "is_mythical": true,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
